import React from "react";
import {Heading, Table} from "react-bulma-components";
import {readableDate} from "../../utils";
import logo from "../Nav/img/Logo.jpg";
import {Columns} from "react-bulma-components";

class PrintRental extends React.Component {
  render() {
    let rental = this.props.data;
    let insuranceAmount = this.props.insurance | 0
    let hireAmount = this.props.hire | 0

    const fixHistory = (history) => {
      return history.replace("\n", "<br/>")
    };

    let heading = `${rental.customer ? rental.customer.display_name : ""} - ${rental.vehicle ? rental.vehicle.registration : ""} - ${readableDate(rental.start_date)}`

    return (
      <div>
        <Columns>
          <img src={logo} style={{width: '110px', height: '35px'}} alt="Rentals Direct Ltd"/>
          <h2 className="rental-card-print-title" data-testid={"title-1"}>
            {heading}
          </h2>
        </Columns>

        <Columns>
          <Columns.Column className="is-one-half">
            <Heading size={6}>Vehicle Info</Heading>
            <Table bordered size={"fullwidth"}>
              <tbody>
              <tr>
                <td className="header-row">Registration</td>
                <td
                  data-testid={"vehicle-registration"}>{rental.vehicle ? rental.vehicle.registration : ""}</td>
              </tr>
              <tr>
                <td className="header-row">Make</td>
                <td
                  data-testid={"vehicle-make"}>{rental.vehicle ? rental.vehicle.make ? rental.vehicle.make.name : "" : ""}</td>
              </tr>
              <tr>
                <td className="header-row">Model</td>
                <td
                  data-testid={"vehicle-model"}>{rental.vehicle ? rental.vehicle.model ? rental.vehicle.model.name : "" : ""}</td>
              </tr>
              <tr>
                <td className={"header-row"}>Variant</td>
                <td data-testid={"vehicle-variant"}>{rental.vehicle ? rental.vehicle.variant ?? "" : ""}</td>
              </tr>
              </tbody>
            </Table>
            <Heading size={6}>Rate</Heading>
            {rental.rental_type === 'LT' &&
              <Table bordered size={"fullwidth"}>
                <tbody>
                <tr>
                  <td className="header-row">Weekly Rate</td>
                  <td
                    data-testid={"rate-weekly"}>£{(rental.long_term_weekly ? rental.long_term_weekly : 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                </tr>
                <tr>
                  <td className="header-row">Daily Rate</td>
                  <td
                    data-testid={"daily-rate"}>£{(rental.long_term_weekly ? rental.long_term_weekly / 7 : 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                </tr>
                <tr>
                  <td className="header-row">Chargeable From</td>
                  <td
                    data-testid={"chargeable-from"}>{rental.start_date ? readableDate(rental.start_date) : ""}</td>
                </tr>
                <tr>
                  <td className="header-row">Mileage Allowance (p.a.)</td>
                  <td
                    data-testid={"mileage-allowance"}>{rental.mileage_allowance ? rental.mileage_allowance : ""}</td>
                </tr>
                <tr>
                  <td className="header-row">Excess Mileage Charge</td>
                  <td
                    data-testid={"excess-per-mile"}>£{(rental.excess_mileage_charge_per_mile ? rental.excess_mileage_charge_per_mile : 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                </tr>
                </tbody>
              </Table>
            }{rental.rental_type === 'ST' &&
              <Table bordered size={"fullwidth"}>
                <tbody>
                <tr>
                  <td className="header-row">Day 1-2 Rate</td>
                  <td
                    data-testid={"rate-day1"}>£{((rental.rate_card && rental.rate_card.day1_2_rate) ? rental.rate_card.day1_2_rate : 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                </tr>
                <tr>
                  <td className="header-row">Day 3-6 Rate</td>
                  <td
                    data-testid={"day2_5_rate"}>£{((rental.rate_card && rental.rate_card.day3_6_rate) ? rental.rate_card.day3_6_rate : 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                </tr>
                <tr>
                  <td className="header-row">Day 7-27 Rate</td>
                  <td
                    data-testid={"day6_27-rate"}>£{((rental.rate_card && rental.rate_card.day7_27_rate) ? rental.rate_card.day7_27_rate : 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                </tr>
                <tr>
                  <td className="header-row">Day 28+ Rate</td>
                  <td
                    data-testid={"day28+"}>£{((rental.rate_card && rental.rate_card.day28_plus_rate) ? rental.rate_card.day28_plus_rate : 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                </tr>
                <tr>
                  <td className="header-row">Insurance Daily Charge</td>
                  <td
                    data-testid={"excess-per-mile"}>£{(rental.insurance_daily ? rental.insurance_daily : 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                </tr>
                </tbody>
              </Table>
            }
            <Heading size={6}>Insurance</Heading>
            <Table bordered size={"fullwidth"}>
              <tbody>
              <tr>
                <td className="header-row">Policy Name</td>
                <td
                  data-testid={"policy-name"}>{rental.policy_name ? rental.policy_name : ""}</td>
              </tr>
              <tr>
                <td className="header-row">Insurer</td>
                <td
                  data-testid={"policy-insurer"}>{rental.insurer ? rental.insurer : ""}</td>
              </tr>
              <tr>
                <td className="header-row">Policy Number</td>
                <td
                  data-testid={"policy-number"}>{rental.policy_number ? rental.policy_number : ""}</td>
              </tr>
              <tr>
                <td className="header-row">Expiry</td>
                <td
                  data-testid={"insurance-expiry"}>{rental.insurance_expiry ? readableDate(rental.insurance_expiry) : ""}</td>
              </tr>
              </tbody>
            </Table>
          </Columns.Column>
          <Columns.Column>
            <Heading size={6}>Hirer/Driver/Insurer</Heading>
            <Table bordered size={"fullwidth"}>
              <tr>
                <td className="header-row">Name</td>
                <td
                  data-testid={"customer-name"}>{rental.customer ? rental.customer.display_name : ""}</td>
              </tr>
              <tr>
                <td className="header-row">Address</td>
                <td data-testid={"customer-address"}><pre>{`${rental.customer ? rental.customer.address_line1 : ""}\n${rental.customer ? rental.customer.town :
                  ""}\n${rental.customer ? rental.customer.postcode : ""}`}</pre>
                </td>
              </tr>
              <tr>
                <td className={"header-row"}>Phone</td>
                <td data-testid={"customer-phone"}>{rental.customer ? rental.customer.phone : ""}</td>
              </tr>
              <tr>
                <td className={"header-row"}>Email</td>
                <td data-testid={"customer-email"}>{rental.customer ? rental.customer.email : ""}</td>
              </tr>
              <tr>
                <td className={"header-row"}>NI Number</td>
                <td data-testid={"ni-number"}>{rental.ni_number ? rental.ni_number : ""}</td>
              </tr>
              <tr>
                <td className={"header-row"}>Licence No</td>
                <td data-testid={"customer-email"}>{rental.licence_number ? rental.licence_number : ""}</td>
              </tr>
              <tr>
                <td className={"header-row"}>License Held</td>
                <td data-testid={"customer-email"}>{rental.license_held ? rental.license_held : ""}</td>
              </tr>
            </Table>
            <Heading size={6}>Payer (If different from driver)</Heading>
            <Table bordered size={"fullwidth"}>
              <tr>
                <td className="header-row">Name</td>
                <td
                  data-testid={"customer-name"}>{rental.payer ? rental.payer.display_name : ""}</td>
              </tr>
              <tr>
                <td className="header-row">Address</td>
                <td data-testid={"payer-address"}><pre>{`${rental.payer ? rental.payer.address_line1 : ""}\n${rental.payer ? rental.payer.town :
                  ""}\n${rental.payer ? rental.payer.postcode : ""}`}</pre>
                </td>
              </tr>
              <tr>
                <td className={"header-row"}>Phone</td>
                <td data-testid={"customer-phone"}>{rental.payer ? rental.payer.phone : ""}</td>
              </tr>
              <tr>
                <td className={"header-row"}>Email</td>
                <td data-testid={"customer-email"}>{rental.payer ? rental.payer.email : ""}</td>
              </tr>
              <tr>
                <td className={"header-row"}>Sign to accept liability for all payments to be made on time for this
                  hire
                </td>
                <td></td>
              </tr>
            </Table>
          </Columns.Column>
        </Columns>
        <Columns>
          {rental.rental_type === 'LT' &&
            <Table size={"fullwidth"} textAlign={"center"}>
              <thead>
              <tr>
                <th>Long Term Lease Hire for {rental.term} Weeks Minimum</th>
              </tr>
              <tbody>
              <tr>
                <td>Early Return Penalty Charge Of £{rental.early_return_penalty_per_week} Per Week To The End Of The
                  Contract
                  Term
                </td>
              </tr>
              <tr>
                <td>Any extras fitted to the vehicle will require full payment if returned early</td>
              </tr>
              <tr>
                <td>£50 Per Month Fair Wear & Tear Allowance - Used against off hire repairs (min 12 month hire
                  required)
                </td>
              </tr>
              <tr>
                <td>Excess Mileage Over 60000 is charged at 0.25p per mile (Peugeot vehicles only)</td>
              </tr>
              </tbody>
              </thead>
            </Table>
          }
          {rental.rental_type === 'ST' &&
            <div>
              <Heading size={6}>Short Term Hire Charges</Heading>
              <Table size={"fullwidth"} textAlign={"center"}>
                <thead>
                <tr>
                  <th>Charge</th>
                  <th>Exc VAT</th>
                  <th>Inc VAT</th>
                </tr>
                <tbody>
                <tr>
                  <td>Vehicle Hire</td>
                  <td>£{hireAmount.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                  <td>£{(hireAmount * 1.2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                </tr>
                <tr>
                  <td>Insurance</td>
                  <td>£{insuranceAmount.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td>£{(hireAmount + insuranceAmount).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                  <td>£{((1.2 * hireAmount) + insuranceAmount).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</td>
                </tr>
                </tbody>
                </thead>
              </Table>
            </div>
          }
          <Heading size={6}>By signing the below, you are confirming that you have read, understood and agree to the
            Rentals Direct Ltd Terms & Conditions</Heading>
          <Table size={"fullwidth"}>
            <thead>
            <tr>
              <th></th>
              <th>Customer/Driver</th>
              <th>Rentals Direct</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td></td>
              <td>Signature:<br/></td>
              <td>Signature:<br/></td>
            </tr>
            <tr>
              <td></td>
              <td>Name:<br/></td>
              <td>Name:<br/></td>

            </tr>
            </tbody>
          </Table>
        </Columns>
      </div>
    );
  }
}

export default PrintRental;
